export default function authFileHeader() {
    let user = JSON.parse(localStorage.getItem('user'));
        if (user && user.token) {
        return {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + user.token
        };
    } else {
        return {};
    }
}